import { useChartWidth } from './useChartWidth';

/** Inner-plot pixels per year for short axis labels (0, 1, 2…). */
export const MIN_PX_PER_YEAR = 48;

/** Inner-plot pixels per calendar year (2026, 2027…). */
export const MIN_PX_PER_CALENDAR_YEAR = 40;

/**
 * Measure the card width, then expand the plot when many years would otherwise
 * be crushed into a phone-sized card. Pair with ChartHScroll.
 */
export function useChartPlotWidth(opts: {
  unitCount: number;
  minPxPerUnit: number;
  leftMargin: number;
  rightMargin: number;
}) {
  const { width: containerWidth, onLayout } = useChartWidth();
  const units = Math.max(opts.unitCount, 1);
  const minPlot =
    units * opts.minPxPerUnit + opts.leftMargin + opts.rightMargin;
  const plotWidth = Math.max(containerWidth, minPlot);
  const scrolls = plotWidth > containerWidth + 0.5;

  return { containerWidth, plotWidth, scrolls, onLayout };
}
